import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { Component } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { Modal, ModalBody, ModalFooter } from 'reactstrap';
import '../../assets/css/login.scss';
import { default as defaultImage } from '../../assets/images/placeholder-sm.png';
import ImageHelper from '../../helpers/ImageHelper';

class RewardItemsModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      reason: '',
      loadingCode: false,
      showTermModal: false,
      error: '',
      bindiscount: '',
      banks: []
    };
  }

  componentDidMount() {

  }

  render() {
    const { currentRewardData } = this.props;
    return (
      <React.Fragment>
        <Modal
          isOpen={this.props.showModal}
          toggle={this.props.toggleModal}
          className="modal sub-modal-ritems"
        >
          <div className="modal-header no-border card-color">
            <h5 className="modal-title fw-bold fs-4 card-font-color">Reward</h5>
            <div
              className={`close-icon`}
              onClick={this.props.toggleModal}
              style={{ cursor: 'pointer' }}
            >
              <FontAwesomeIcon icon={faTimes} color='var(--card-subtitle-color)' size={'1x'} />
            </div>
          </div>

          <ModalBody className="card-color" style={{ overflowX: 'hidden' }}>
            <section
              className="items items-custom small-grid-layout mb-3"
              data-category-id="category-3042"
            >

              <div className="container" style={{ height: "100%" }}>
                <div className="row">
                  {currentRewardData.map((row) => {
                    return (<div className="col-lg-6 col-md-6 mt-1 mb-3 card_layout_custom  ">
                      <div className="hovernow">
                        <div
                          className="listmenu item grid-items-item card-color media"
                          style={{ borderLeftColor: "rgb(228, 101, 142)" }}
                        >
                          <div style={{ width: "100%", height: "100%" }}>
                            <div className="item-row-section">
                              <div
                                className="item-row-section-first-item d-flex flex-column align-items-center"
                                style={{ position: "relative" }}
                              >
                                <div className="sc-papXJ BRdOD f3 custom_item-name-new card-font-color">
                                  <p className="card-font-color">
                                    {row.Menu?.menu_name}
                                  </p>
                                </div>

                              </div>
                              <div className="item-row-section-second-item">
                                <div className="item-image-rating-container item-image-rating-container-custom">
                                  <LazyLoadImage
                                    width="90px"
                                    height="200px"
                                    placeholderSrc={defaultImage}
                                    effect="blur"
                                    className="item-image"
                                    src={
                                      ImageHelper.getImageURL(
                                        row.Menu.menu_photo,
                                        '?func=fit&w=3000&h=300'
                                      ) || defaultImage
                                    }
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>)
                  })}
                </div>
              </div>
            </section>
          </ModalBody>
          <ModalFooter className="no-border card-color d-flex justify-content-center">

          </ModalFooter>

        </Modal>
      </React.Fragment>
    );
  }
}

export default RewardItemsModal;